import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
function FetchNotificationSettingsService(token) {
    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/fetchNotificationSettings`, '', {
     
    headers: {
        'Authorization': token,
      }
    })
    .then(res => {
      notify.NotifySuccess("Action Settings data fetched successfully. Thank You!");
      return res.data;
    })
    .catch(error => {
      console.log(error);
      notify.NotifyError("An error occurred while fetching Action Settings data. Please try again later.");
      return false;
    });
  }
  
  export default FetchNotificationSettingsService;
  